import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { WorkflowService } from "../../services/workflow-service";
import { WorkflowConfigService } from "../../services/workflow-config-service";

export class BulkExecuteWorkFlowModalController {
    static $inject = ["$q", "$uibModalInstance", "notifyService", "workflowService", "workflowConfigService",
        "parentEntityID", "charTypeID", "templateID", "recordIDTitlesDictionary", "processID", "actionID", "statusID"];

    title: string;
    recordCount: number;
    bulkWorkflowActions: Models.IWFAction[] = [];
    notifications: Models.IWFNotificationWithAttachments[] = [];
    selectedNotification: Models.IWFNotificationWithAttachments;
    showEditNotification: boolean = false;
    editNotificationView: number;
    showJobProgressStatus: boolean;
    showProgressSpinner: boolean;
    jobId: string;
    jobTitle: string;
    progressStatus: string;
    loading: boolean = true;

    constructor(
        private $q: ng.IQService,
        private $uibModal: ng.ui.bootstrap.IModalServiceInstance,
        private notifyService: NotifyService,
        private workflowService: WorkflowService,
        private workflowConfigService: WorkflowConfigService,
        private parentEntityID: string,
        private charTypeID: number,
        private templateID: number,
        private recordIDTitlesDictionary: { [key: number]: string },
        private processID?: number,
        private actionID?: number,
        private statusID?: number) {

        if (this.charTypeID == Consts.CharTypeIDs.right) {
            this.title = "Bulk Workflow"
            this.loading = true;
            this.LoadAvailableActions();
        }
        else {
            this.loading = false;
            this.BulkExecuteWorkflow();
        }

        if (this.recordIDTitlesDictionary != undefined) {
            this.recordCount = _.keys(this.recordIDTitlesDictionary).length;
        }
    }

    public Cancel() {
        this.$uibModal.dismiss();
    }

    LoadAvailableActions() {
        this.notifyService.startProgress();
        this.workflowService.getAvailableWorkflowActions(Consts.CharTypeIDs.right, this.templateID, this.statusID)
            .then((result) => {
                this.bulkWorkflowActions = result;
                this.processID = this.bulkWorkflowActions[0].processID;
                this.loading = false;
                this.notifyService.endProgress();
            });
    }

    DeselectRecord(recordID: number) {
        delete this.recordIDTitlesDictionary[recordID];
        this.recordCount = _.keys(this.recordIDTitlesDictionary).length;
    }

    BulkExecuteWorkflow() {
        this.notifyService.startProgress();
        var selectedRecordIDs: number[] = [];
        selectedRecordIDs = _.keys(this.recordIDTitlesDictionary).map((key) => _.parseInt(key));

        this.GetPreviewNotifications()
            .then((result) => {
                this.notifications = result.notifications;
                this.notifyService.endProgress();

                if (!_.isEmpty(this.notifications)) {
                    this.selectedNotification = this.notifications[0];
                    this.SetEditNotificationView(0);
                    this.showEditNotification = true;
                }
                else {
                    this.notifyService.startProgress();
                    this.workflowService.createBatchID()
                        .then((batchIDResult) => {
                            var batchID = batchIDResult.batchID;

                            this.workflowService.executeWorkflowJob(this.charTypeID, selectedRecordIDs, this.actionID, this.processID, batchID)
                                .then((result) => {
                                    this.showJobProgressStatus = true;
                                    this.showProgressSpinner = true;
                                    this.jobId = result.jobID;
                                    this.jobTitle = result.jobTitle;
                                    this.notifyService.endProgress();
                                    this.$uibModal.close(result);
                                });
                        });
                }
            });
    }

    GetPreviewNotifications(): ng.IPromise<any> {
        return this.workflowConfigService.getPreviewNotifications(this.processID, this.actionID);
    }

    SetEditNotificationView(val: number) {
        this.editNotificationView = val;
    }

    SendNotifications() {
        this.notifyService.startProgress();
        var promises = [];

        var selectedRecordIDs: number[] = [];
        selectedRecordIDs = _.keys(this.recordIDTitlesDictionary).map((key) => _.parseInt(key));

        if (selectedRecordIDs.length > 0) {
            _.forEach(selectedRecordIDs, (recID) => {
                var request: Models.IWFSendNotificationsRequest = {
                    charTypeID: this.charTypeID,
                    recordID: recID,
                    processID: this.processID,
                    actionID: this.actionID,
                    notifications: this.notifications,
                    downloadURLs: {}
                };

                promises.push(this.workflowService.sendNotifications(request));
            });

            this.$q.all(promises)
                .then(() => {
                    this.notifyService.notifySuccess("Workflow action successful!");
                })
                .finally(() => {
                    this.showEditNotification = false;
                    this.notifyService.endProgress();
                    this.$uibModal.close();
                });
        }
    }
}